import { defineRoutes } from '../utils';

/**
 * Common routes — top-level pages that don't belong to a specific domain.
 */
export const commonRoutes = defineRoutes({
  home_dashboard: {
    path: '/',
    isPublic: false,
  },
  dashboard: {
    path: '/dashboard',
    isPublic: false,
  },
  ai_agent: {
    path: '/ai',
    isPublic: false,
  },
});
